export const PORTAL_PREFIX = '/:accountName/portal_';

export const REQUEST_BASE_ROUTE = '/portal_';
